import { cn } from "../../lib/utils";

const SidebarActionButton = ({ onClick, dataAttr, isActive, forceHover, hasPin, iconClass }) => {
	return (
		<button
			type="button"
			className={cn(
				"flex rounded-[2px] p-2 cursor-pointer hover:bg-interactive-10 select-none relative",
				forceHover && "bg-interactive-10",
				isActive && "bg-interactive-100 hover:bg-interactive-100"
			)}
			onClick={onClick}
			{...dataAttr}
		>
			<span
				className={cn(
					"icon_16 default icon_mask",
					iconClass,
					isActive ? "!bg-white" : "!bg-interactive-100"
				)}
			/>
			{hasPin && (
				<div className="absolute w-3 shadow-[0_0_0_2px] shadow-white h-3 bg-interactive-100 rounded-full -top-[3px] -right-[3px]"></div>
			)}
		</button>
	);
};

SidebarActionButton.displayName = "SidebarActionButton";

export default SidebarActionButton;
